import '../signup/main.css';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined, WarningOutlined } from '@ant-design/icons';
import { jwtDecode } from 'jwt-decode';
import { getDoc } from 'firebase/firestore';
import { shareLinkDoc, SHARE_LINK_FLAG, SHARE_LINK_MAX_AGE_MS } from '../../funcs/shareLoginLink';

// Mirrors decodeTokenToUserData in pages/login/main.js
function decodeTokenToUserData(token) {
    let jwt_token = jwtDecode(token);
    let final_data = {};
    if (jwt_token?.default_page?.connected_instagram_account != undefined) {
        final_data = jwt_token?.default_page?.connected_instagram_account;
    } else {
        final_data = jwt_token["default_page"] || {};
    }
    final_data["agency"] = jwt_token?.agency;
    final_data["user_id"] = jwt_token?.user_id;
    final_data["name"] = jwt_token?.name;
    final_data["emailid"] = jwt_token?.emailid;
    final_data["workspace_id"] = jwt_token?.workspace_id;
    final_data["workspace_role"] = jwt_token?.workspace_role;
    return final_data;
}

function ShareLogin() {
    const { id } = useParams();
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!id) return;

        const loginFromLink = async () => {
            try {
                const snap = await getDoc(shareLinkDoc(id));
                if (!snap.exists()) {
                    setError("This link is invalid or has already been used. Please ask for a new link.");
                    return;
                }
                const link = snap.data();
                if (link.status === "connected") {
                    setError("This account is already connected. You can close this page.");
                    return;
                }
                if (!link.token || (link.created_at && Date.now() - link.created_at > SHARE_LINK_MAX_AGE_MS)) {
                    setError("This link has expired. Please ask for a new link.");
                    return;
                }

                // Auto-login as the managed account, then continue to the
                // normal connect page — the flag lets the redirect pages
                // update the doc once the connection completes.
                localStorage.setItem("token", link.token);
                sessionStorage.clear();
                try {
                    localStorage.setItem("userData", JSON.stringify(decodeTokenToUserData(link.token)));
                } catch (e) { /* connect flow only needs the token */ }
                localStorage.setItem(SHARE_LINK_FLAG, id);

                window.location.replace(link.show_ig_connect ? "/ig-connect?show_ig_connect=true" : "/ig-connect");
            } catch (err) {
                console.error("share-login failed", err);
                setError("Couldn't open this link. Check your internet connection and try again.");
            }
        };

        loginFromLink();
    }, [id]);

    return (
        <div className='account-setup'>
            <img src="/logo192.png" alt="Logo" style={{ height: '62px', width: '62px' }} />
            <div style={{ maxWidth: '420px', margin: '80px auto 0', textAlign: 'center', padding: '0 16px' }}>
                {!error ? (
                    <p>
                        <Spin indicator={<LoadingOutlined spin />} style={{ marginRight: '10px' }} />
                        Logging you in, please wait…
                    </p>
                ) : (
                    <>
                        <p style={{ fontSize: '42px', margin: '0 0 8px' }}><WarningOutlined /></p>
                        <p>{error}</p>
                    </>
                )}
            </div>
        </div>
    );
}

export default ShareLogin;
